import standardCarousel from "@/libs/standard-carousel";

export function carousel(options = {}) {
    return {
        _flkty: null,
        init() {
            const track = this.$refs.track;
            if (!track) return;
            this._flkty = standardCarousel(track, '[data-cell]', options);
        },
        destroy() {
            if (this._flkty) this._flkty.destroy();
        },
        prev() {
            if (this._flkty) this._flkty.previous();
        },
        next() {
            if (this._flkty) this._flkty.next();
        },
    };
}
